import { AnnouncementEventType } from '@api';
import { ArtistAnchor, TourAnchor } from '@common';
import { faCalendar, faClock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { getAnnouncementTimeLabel } from './helpers';

const TRANS_KEY = 'TOURING_SCHEDULE';

type AnnouncementHoverCardPropsType = {
  announcement: AnnouncementEventType;
};

export const AnnouncementHoverCard: React.FC<
  AnnouncementHoverCardPropsType
> = ({ announcement }) => {
  const { t } = useTranslation('dashboard');
  const timeLabel = getAnnouncementTimeLabel(announcement);

  return (
    <Stack align="center">
      <Text fw={700}>
        <ArtistAnchor artist={announcement.artist} />
        {' | '}
        <TourAnchor tour={announcement.tour} />
      </Text>
      {announcement.duration !== null ? (
        <Text>
          {t(`${TRANS_KEY}.DURATION_HOURS`, {
            duration: announcement.duration,
          })}
        </Text>
      ) : null}
      <Stack align="center" gap={2}>
        <Group gap={2}>
          <FontAwesomeIcon icon={faCalendar} size="sm" />
          <Text>{dayjs(announcement.date).format('DD.MM.YYYY')}</Text>
        </Group>
        {timeLabel !== null ? (
          <Group gap={2}>
            <FontAwesomeIcon icon={faClock} size="sm" />
            <Text>{timeLabel}</Text>
          </Group>
        ) : null}
      </Stack>
    </Stack>
  );
};
